/* eslint-disable */

import React from 'react';
import PropTypes from 'prop-types';

import Modal from 'components/Modal';
import ModalHeader from 'components/ModalHeader';

import './styles.scss'

const TermsModal = ({ isOpen, backHandl }) => (
  <Modal isOpen={isOpen}>
    <ModalHeader backHandl={backHandl}>
        Terms and conditions
    </ModalHeader>

    <p className="terms-text">
    This Offer to Lease is subject to the following terms and conditions:
    <br/> <br />1. I/We have read and fully understand the terms and conditions of this agreement, and hereby consent to and understand that these terms and conditions will become part of the Vehicle Lease Agreement as fully and completely and to same extent as if it had been incorporated therein.
    <br/> <br />2. The Vehicle Lease Agreement will be prepared from the information contained herein and duly executed by both the Lessee and the Lessor.
    <br/> <br />3. This Offer to Lease is subject to final approval by the Lessor at its sole discretion and constitutes an agreement on the part of the Lessee and the Lessor when it is accepted in writing by authorized officer of the Lessor. 
    <br/> <br />4. I hereby acknowledge receipt of a copy of this Offices to Lease.
    <br/> <br />5. The Lessee further agrees that if he does not accept delivery of the motor vehicle in accordance with the terms hereof, this order may be cancelled by the Lessor and all monies paid as deposit, may be retained by Lessor as liquidated damages and not as a penalty.
    <br/> <br />6. The Lessee must obtain, at it’s own experience, a standard automobile insurance policy acceptable to the Lessor with the following minimum vehicle insurance coverage: (i) Third party liability with a combined single occurrence limit of at least $1,000,000; (ii) Comprehensive fire and theft with a maximum deductible of $1000; (iii) Collision with a maximum deductible of $1000. In addition, the lessee acknowledges and understands that the vehicle will not be delivered to the Lessee until satisfactory evidence of insurance meeting the requirements above has been received by the Lessor.
    </p>
  </Modal>
);

TermsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  backHandl: PropTypes.func.isRequired
};

export default TermsModal;



// WEBPACK FOOTER //
// ./src/pages/Signature/Terms/index.js